import type { SvgComponent } from '@/types/SvgComponent';

export const ImageSlashIcon: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}

      <path
        d="M4.5 3.75C4.08579 3.75 3.75 4.08579 3.75 4.5V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.276M20.25 17.5669V15.6339V4.5C20.25 4.08579 19.9142 3.75 19.5 3.75H8"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.1181 10.0001C9.84339 10.3069 9.44425 10.5001 9 10.5001C8.17157 10.5001 7.5 9.82848 7.5 9.00005C7.5 8.50482 7.73999 8.06565 8.11002 7.79248"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.31494 20.2499L10.4548 15.1095L12.5643 13M20.2503 13.5645L16.6559 9.96923C16.5862 9.8995 16.5035 9.84418 16.4125 9.80644C16.3214 9.76869 16.2238 9.74927 16.1253 9.74927C16.0267 9.74927 15.9291 9.76869 15.838 9.80644C15.747 9.84418 15.6643 9.8995 15.5946 9.96923L14.9521 10.6118L14.3097 11.2543"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M3 2L21 22" stroke="currentColor" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
